import { useState, useEffect } from 'react';
import { themeQuartz } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import "./AgentCriteriaAnalyticsGrid.css";

const CONVERSATIONS_LIST_PATH = '/supervision/conversations/list';

const AgentCriteriaAnalyticsGrid = ({ data, criteriaId, criteriaResults = [] }) => {
    const [rowData, setRowData] = useState(data || []);

    const buildConversationsUrl = (agent, extraFilters = {}) => {
        const params = new URLSearchParams();
        if (criteriaId != null) params.append("criteria_ids", criteriaId);
        if (agent) params.append("agent_id", agent);
        (extraFilters.criteria_results || []).forEach((result) => params.append("criteria_results", result));
        return `${CONVERSATIONS_LIST_PATH}?${params.toString()}`;
    };

    const columnDefs = [
        { headerName: "#", field: "id", width: 70 },
        {
            headerName: "Agent Name",
            field: "agent",
            flex: 1,
            cellRenderer: (params) => (
                <a
                    href={buildConversationsUrl(params.value, { criteria_results: criteriaResults })}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "var(--main)", cursor: "pointer" }}
                >
                    {params.value}
                </a>
            )
        },
        { headerName: "Pass Rate", field: "passRate", sortable: true },
        { headerName: "Number of Interactions", field: "interactions" },
        {
            headerName: "Number of Failed Interactions",
            field: "failed",
            cellRenderer: (params) =>
                params.value ? (
                    <a
                        href={buildConversationsUrl(params.data.agent, { criteria_results: ["fail"] })}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "var(--main)", cursor: "pointer" }}
                    >
                        {params.value}
                    </a>
                ) : params.value
        }
    ];

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
    };

    useEffect(() => {
        setRowData(data || []);
    }, [data]);
    return (
        <div style={{ height: 300 }} className="ag-theme-alpine">
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                theme={themeQuartz}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationPageSize={5}
            />
        </div>
    )
};

export default AgentCriteriaAnalyticsGrid;